export default __webpack_public_path__ + "static/media/download-app-old.2372f7a5.png";